import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/** Colunas do modelo de importação de NFS-e (emitidas). */
export const NFSE_EXCEL_HEADERS = [
  'TomadorCnpjCpf',
  'TomadorNome',
  'ValorServico',
  'Discriminacao',
  'CodigoItemServico',
  'Competencia',
  'AliquotaIss',
];

const EXEMPLO = {
  TomadorCnpjCpf: '00000000000191',
  TomadorNome: 'Cliente Exemplo Ltda',
  ValorServico: 1500.0,
  Discriminacao: 'Serviços de consultoria — competência do mês',
  CodigoItemServico: '01.07',
  Competencia: '2026-07-01',
  AliquotaIss: 2.0,
};

export function downloadModeloNfseExcel() {
  const ws = XLSX.utils.json_to_sheet([EXEMPLO], { header: NFSE_EXCEL_HEADERS });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'NFS-e');
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'modelo-import-nfse.xlsx');
}
